import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface ProfileDetail {
  id: string
  color?: string
  firstName?: string
  lastName?: string
  avatarUrl?: string
  about?: string
  unavailable?: boolean
  unavailableUntil?: string
  jobField?: string
  companyName?: string
  districtName?: string
  schoolName?: string
  keywords?: string[]
  threadId?: string
  favorite?: boolean
  blocked?: boolean
  notes?: string
  matchStrengths?: Array<{
    label: string
    score: number
  }>
}

export const useProfileById = (profileId?: string) => {
  const fetchWithAuth = useFetchWithAuth()

  const getProfileById: QueryFunction<ProfileDetail> = async () => {
    if (!profileId) {
      throw new Error('Profile ID is required')
    }

    try {
      const responseData = await fetchWithAuth(`${URL}/profile/${profileId}`, {
        method: 'GET',
      })
      return {
        ...responseData,
      }
    } catch (error) {
      console.error('Error fetching profile by ID:', error)
      return {
        errors: [
          {
            message:
              error instanceof Error ? error.message : 'Unknown error occurred',
          },
        ],
      }
    }
  }

  return useQuery({
    queryKey: ['profile', profileId] as const,
    queryFn: getProfileById,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!profileId && profileId.length > 0,
  })
}
